import { FC } from 'react';
import useMediaQuery from '../CustomHooks/useMediaQuery';

type Props = {
  fullMargin?: boolean;
};

export const BoneoImageBroker: FC<Props> = ({ fullMargin }) => {
  const isBigScreen = useMediaQuery('(min-width: 47rem)');

  return (
    <>
      <div
        className={`mb-6 lg:mb-16 lg:mt-8 max-w-7xl mx-auto overflow-hidden `}
      >
        <a
          className={`${
            !fullMargin ? 'mt-4' : ''
          } block max-w-full min-h-[195px]`}
          href="https://www.boneo.se/?utm_source=lansfast&utm_medium=referral&utm_campaign=boneo-PaG"
          target="_blank"
        >
          {isBigScreen === false && (
            <img
              loading="lazy"
              className={`${!fullMargin ? 'mt-4' : ''} w-full rounded-md`}
              src="/Images/boneo/boneo-phone.jpg?format=webp&quality=80"
              alt="Boneo"
              width={600}
              height={900}
            />
          )}
          {isBigScreen && (
            <img
              loading="lazy"
              className="rounded-md w-full"
              src="/Images/boneo/boneo-desktop.jpg?format=webp&quality=80"
              alt="Boneo"
              width={1180}
              height={200}
            />
          )}
        </a>
      </div>
    </>
  );
};
